

PollEv.env.set({
  
  root_url:         "PLACEHOLDER_ROOT_URL_PLACEHOLDER",
  

  
  api_url:          "PLACEHOLDER_API_URL_PLACEHOLDER",
  

  
  cdn_url:          "PLACEHOLDER_CDN_URL_PLACEHOLDER",
  

  
  firehose_url:     "PLACEHOLDER_FIREHOSE_URL_PLACEHOLDER",
  

  
  
  firehose_ssl:     PLACEHOLDER_FIREHOSE_SSL_PLACEHOLDER,
  

  
  
  secure_protocol:  "PLACEHOLDER_SECURE_PROTOCOL_PLACEHOLDER",
  

  
  

  
  

  
  
  image_bucket_url: "PLACEHOLDER_IMAGE_BUCKET_URL_PLACEHOLDER",
  

  
  imgix_url: "PLACEHOLDER_IMGIX_URL_PLACEHOLDER",
  

  
  imgix_token: "PLACEHOLDER_IMGIX_TOKEN_PLACEHOLDER",
  

  
  poll_renderer_url: "PLACEHOLDER_POLL_RENDERER_URL_PLACEHOLDER",
  

  

  
  viz_url: "PLACEHOLDER_VIZ_URL_PLACEHOLDER",
  

  
  mobile_url: "PLACEHOLDER_MOBILE_URL_PLACEHOLDER",
  

  

  
  proxy_enabled: PLACEHOLDER_PROXY_ENABLED_PLACEHOLDER,
  

  

  

  
  ga_tracking_id: "PLACEHOLDER_GA_TRACKING_ID_PLACEHOLDER",
  

  

  
  ddag_url: "PLACEHOLDER_DDAG_URL_PLACEHOLDER",
  

  
  
  revision: "PLACEHOLDER_REVISION_PLACEHOLDER",
  

  

  

  

  
  cutlass_base_url: "PLACEHOLDER_CUTLASS_BASE_URL_PLACEHOLDER",
  

  
  aftermath_url: "PLACEHOLDER_AFTERMATH_URL_PLACEHOLDER",
  

  
  __no_comma: true
});
